import { z } from 'zod';
import type { IsoDate } from './common.js';

/* ---------- Reminders («Recuérdamelo») ---------- */

export const createReminderSchema = z.object({
  teamId: z.uuid(),
  /** The message to come back to (none: a free reminder). */
  messageId: z.uuid().optional(),
  note: z.string().trim().max(300).optional(),
  remindAt: z.iso.datetime(),
});
export type CreateReminderInput = z.infer<typeof createReminderSchema>;

export interface Reminder {
  id: string;
  teamId: string;
  channelId: string | null;
  messageId: string | null;
  /** What the reminder is about: the note, or the start of the message. */
  text: string;
  remindAt: IsoDate;
  createdAt: IsoDate;
}

/* ---------- Scheduled messages ---------- */

export const scheduleMessageSchema = z.object({
  body: z.string().trim().min(1, 'Mensaje vacío').max(4000),
  sendAt: z.iso.datetime(),
  parentId: z.uuid().optional(),
});
export type ScheduleMessageInput = z.infer<typeof scheduleMessageSchema>;

export interface ScheduledMessage {
  id: string;
  channelId: string;
  parentId: string | null;
  body: string;
  sendAt: IsoDate;
  createdAt: IsoDate;
}
